import { styled } from '@mui/material';
import { breakpoints, DisplayCard, FrontTable } from 'src/ui-components';

import { useTableData } from './hooks/useTableData';

export const SalesTablePage = () => {
  const tableData = useTableData();
  return (
    <Wrapper
      title={'Sell Through Over Time by Sales Channel'}
      subtitle={'Raw data of daily sales in dollar over time broken out by sales type'}
    >
      <FrontTable {...tableData} />
    </Wrapper>
  );
};

const Wrapper = styled(DisplayCard)`
  grid-column: 1 / 3;

  ${breakpoints.before.desktop} {
    grid-column: 1 / 1;
  }
`;
